export default __webpack_public_path__ + "static/beauty-butterfly-reference-09485abd872fa6631e5f5af6427ba0c1.png";